import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const ItemImageIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M21 2.45001H3C1.48 2.45001 0.25 3.68001 0.25 5.20001V18.8C0.25 20.32 1.48 21.55 3 21.55H21C22.52 21.55 23.75 20.32 23.75 18.8V5.20001C23.75 3.68001 22.52 2.45001 21 2.45001ZM3 3.95001H21C21.69 3.95001 22.25 4.51001 22.25 5.20001V13.86L16.8 9.32001C16.57 9.13001 16.23 9.13001 16 9.32001L10.68 13.75L8 11.52C7.77 11.33 7.43 11.33 7.2 11.52L1.75 16.06V5.20001C1.75 4.51001 2.31 3.95001 3 3.95001ZM21 20.05H3C2.31 20.05 1.75 19.49 1.75 18.8V17.69L7.6 12.81L10.28 15.04C10.51 15.23 10.85 15.23 11.08 15.04L16.4 10.61L22.25 15.49V18.8C22.25 19.49 21.69 20.05 21 20.05Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

ItemImageIcon.displayName = 'ItemImageIcon';
